<template>
  <div>
    <div class="flex mb-5 label-tooltip-container">
      <h5 class="uppercase">{{label}}</h5>
    </div>
    <span class="small-font mb-5 block default-lh">{{subLabel}}</span>
    <div class="flex currency-flex">
      <h3 v-if="$props.preorder" class="highlight-color mb-0">{{ $t('common.soon') }}</h3>
      <template v-else>
        <h3 class="highlight-color mb-0">{{price}}</h3>
        <span class="small-font bold currency">{{currency}}</span>
      </template>
    </div>
    <div class="flex align-end old-price"
         v-if="oldPrice">
      <h3>{{oldPrice}}</h3>
      <span>{{currency}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    subLabel: String,
    price: [Number, String],
    oldPrice: [Number, String],
    currency: String,
    tooltip: Boolean,
    preorder: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.label-tooltip-container {
  position: relative;

  h5 {
    font-weight: 600;
  }
}

h5 {
  margin-bottom: 0;
  margin: auto;
}
.highlight-color {
  line-height: 1;
  margin-right: 3px;
}

.currency-flex {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;

  @media (#{map-get($breakpoints, sm)}) {
    justify-content: flex-start;
  }
}

.currency {
  color: $black;
  font-size: 14px;
  text-transform: lowercase;
  line-height: unset;
}
h5.uppercase {
  font-size: 16px;
  line-height: 18px;

  @media (#{map-get($breakpoints, sm)}) {
    margin: 0;
  }
}

.default-lh {
  @media (#{map-get($breakpoints, sm)}) {
    text-align: left;
    width: fit-content;
  }
}

h3.highlight-color {
  font-size: 28px;
  line-height: 24px;
}
.tooltip-device {
  position: absolute;
  right: 0;
  display: inline-block;
  height: 18px;
  width: 18px;
  cursor: pointer;
  transform: translateX(-10px);

  @media (#{map-get($breakpoints, sm)}) {
    transform: none;
    margin-left: 8px;
  }
}

.old-price {
  margin: 10px auto 0;
  width: fit-content;
  position: relative;

  @media (#{map-get($breakpoints, sm)}) {
    margin-top: 10px;
    margin-left: 0;
  }

  &::before {
    content: '';
    height: 1px;
    width: 100%;
    background-color: $mtel-red;
    position: absolute;
    top: 50%;
  }

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: $light-black;
    margin: 0;
  }
  span {
    font-size: 16px;
    font-weight: normal;
    color: $checkbox-label;
    text-transform: lowercase;
    margin-left: 5px;
  }
}

.small-font {
  font-size: 1.4rem;
}
</style>
